import PropTypes from 'prop-types';
import { useLanguage } from '@shared/contexts/LanguageContext';
import showVersion from '@/app/version';

/**
 * 共用的頁面底部 Footer 組件
 * 統一格式的聯絡資訊和版權聲明
 */
const PageFooter = ({
    showIcon = true,
    showDonation = true,
    className = '',
}) => {
    const { t } = useLanguage();
    const version = showVersion(false);

    return (
        <footer className={`bg-[#F0EAE4] text-stone-500 py-12 px-8 ${className}`}>
            <div className="flex flex-col items-center text-center">
                {showIcon && (
                    <div className="mb-6">
                        <img src="/image/logo.png" alt={t('header.logoAlt') || t('nav.anniversary')} className="h-14 w-auto" />
                    </div>
                )}

                <div className="w-12 h-1 bg-[#C0392B] mb-6"></div>

                <h4 className="font-serif text-[#B39029] text-lg tracking-[0.4em] mb-6">
                    {t('footer.sharedTitle')}
                </h4>

                <div className="text-sm leading-6 max-w-md mb-6 text-[#6E625B] space-y-1">
                    <p className="font-medium mb-2">{t('footer.contactHeading')}</p>
                    <p className="font-light">{t('footer.copyright')}</p>
                    <p className="font-light">{t('footer.address')}</p>
                    <p className="font-light">{t('footer.phoneFax')}</p>
                    {showDonation && (
                        <p className="font-light">{t('footer.accountName')}</p>
                    )}
                    <p className="font-light">{t('footer.email')}</p>
                    {version && (
                        <p className="font-light text-xs text-stone-400">{t('footer.version').replace('{{version}}', version)}</p>
                    )}
                </div>

                <div className="text-sm tracking-[0.2em] mb-8 font-light text-[#B39029]">
                    {t('footer.monasteryEn')}<br />
                    <span className="mt-1 block uppercase">{t('footer.anniversaryEn')}</span>
                </div>
            </div>
        </footer>
    );
};

PageFooter.propTypes = {
    showIcon: PropTypes.bool,
    showDonation: PropTypes.bool,
    className: PropTypes.string,
};

export default PageFooter;
